"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = exports.StyledSidebarTitle = exports.StyledDrawerSidebar = exports.StyledDrawerChildren = exports.StyledDrawerContent = exports.StyledDrawerWrapper = exports.StyledSidebarHeader = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _tabs = _interopRequireDefault(require("../tabs/tabs.style"));

var _box = _interopRequireDefault(require("../box"));

var _stickyFooter = _interopRequireDefault(require("../../__internal__/sticky-footer/sticky-footer.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledSidebarHeader = _styledComponents.default.div`
  ${({
  isExpanded
}) => (0, _styledComponents.css)`
    position: sticky;
    top: 0;

    ${isExpanded && (0, _styledComponents.css)`
      border-bottom: 1px solid #ccd6db;
    `}
  `}
`;
exports.StyledSidebarHeader = StyledSidebarHeader;
const StyledSidebarTitle = _styledComponents.default.div`
  white-space: nowrap;
  padding: 24px 36px 24px 40px;
`;
exports.StyledSidebarTitle = StyledSidebarTitle;
const StyledDrawerChildren = _styledComponents.default.div`
  flex: 1;
  margin-left: 1px;
  overflow: auto;
`;
exports.StyledDrawerChildren = StyledDrawerChildren;
const StyledDrawerSidebar = (0, _styledComponents.default)(_box.default)`
  ${({
  hasControls,
  isExpanded
}) => (0, _styledComponents.css)`
      ${!isExpanded && (0, _styledComponents.css)`
        display: none;
        opacity: 0;
      `}

      ${isExpanded && (0, _styledComponents.css)`
        display: flex;
        flex-direction: column;
        flex: 1 1 0%;
      `}

      ${hasControls && (0, _styledComponents.css)`
        ${_tabs.default} {
          margin-top: 48px;
          ${!isExpanded && (0, _styledComponents.css)`
            display: none;
          `}
        }
      `}
    `}
`;
exports.StyledDrawerSidebar = StyledDrawerSidebar;

const sidebarVisible = () => (0, _styledComponents.keyframes)`
  0% {opacity: 0;}
  50% {opacity: 0;}
  100% {opacity: 1;}
`;

const sidebarHidden = () => (0, _styledComponents.keyframes)`
  0% {opacity: 1;}
  100% {opacity: 0; display: none;}
`;

const drawerOpen = expandedWidth => (0, _styledComponents.keyframes)`
  0% {
    width: 40px;
    overflow: hidden;
    min-width: 40px;
  }
  100% {
    width: ${expandedWidth};
    min-width: 52px;
  }
`;

const drawerClose = expandedWidth => (0, _styledComponents.keyframes)`
  0% {width: ${expandedWidth};}
  100% {width: 40px;}
`;

const buttonOpen = () => (0, _styledComponents.keyframes)`
  0% {float: right;}
  100% {float: right;}
`;

const buttonClose = () => (0, _styledComponents.keyframes)`
  0% {float: right;}
  80% {float: right;}
  100% {float: left;}
`;

const StyledDrawerContent = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  min-width: 40px;
  width: 40px;
  min-height: 40px;
  height: auto;
  position: relative;
  overflow: auto;
  border-right: 1px solid ${({
  theme
}) => theme.drawer.divider};
  background-color: ${({
  backgroundColor,
  theme
}) => backgroundColor || theme.drawer.background}};

  &.open {
    min-width: 52px;
    width: ${({
  expandedWidth
}) => expandedWidth};

    ${StyledDrawerSidebar}, ${StyledSidebarTitle} {
      display: block;
      opacity: 1;
    }
  }

  &.opening {
    animation: ${({
  animationDuration,
  expandedWidth
}) => (0, _styledComponents.css)`
      ${drawerOpen(expandedWidth)} ${animationDuration}
    `} ease-in-out;

    ${StyledDrawerSidebar}, ${StyledSidebarTitle} {
      animation: ${sidebarVisible} ${({
  animationDuration
}) => animationDuration} ease-in-out;
    }
  }

  &.closed {
    overflow: hidden;
    ${StyledDrawerSidebar}, ${StyledSidebarTitle}, ${_stickyFooter.default} {
      display: block;
      opacity: 0;
    }
  }

  &.closing {
    animation: ${({
  animationDuration,
  expandedWidth
}) => (0, _styledComponents.css)`
      ${drawerClose(expandedWidth)} ${animationDuration}
    `} ease-in-out;

    ${StyledDrawerSidebar}, ${StyledSidebarTitle}, ${_stickyFooter.default} {
      animation: ${sidebarHidden} ${({
  animationDuration
}) => animationDuration} ease-in-out;
    }
  }
`;
exports.StyledDrawerContent = StyledDrawerContent;
const StyledButton = _styledComponents.default.button.attrs({
  type: "button"
})`
  ${({
  animationDuration,
  isExpanded,
  theme
}) => (0, _styledComponents.css)`
    position: absolute;
    top: 24px;
    right: 8px;
    padding: 0;
    width: 24px;
    height: 24px;
    transition: margin-right ${animationDuration} ease-in-out;
    background-color: transparent;
    border: none;
    z-index: 1;
    animation: ${buttonClose} ${animationDuration} ease-in-out;

    &:focus {
      outline: 3px solid ${theme.colors.focus};
    }

    &:hover {
      cursor: pointer;
    }

    ${isExpanded && (0, _styledComponents.css)`
      transform: scaleX(-1);
      animation: ${buttonOpen} ${animationDuration} ease-in-out;
    `}
  `}
`;
exports.StyledButton = StyledButton;
const StyledDrawerWrapper = _styledComponents.default.div`
  display: flex;
  height: ${({
  height
}) => height};
`;
exports.StyledDrawerWrapper = StyledDrawerWrapper;
StyledDrawerContent.defaultProps = {
  theme: _base.default
};
StyledButton.defaultProps = {
  theme: _base.default
};